var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 15.1L15.65 8.05L14.25 6.65L8.6 12.3L5.75 9.45L4.35 10.85L8.6 15.1ZM10 20.5C8.61667 20.5 7.31667 20.2373 6.1 19.712C4.88333 19.1873 3.825 18.475 2.925 17.575C2.025 16.675 1.31267 15.6167 0.788 14.4C0.262667 13.1833 0 11.8833 0 10.5C0 9.11667 0.262667 7.81667 0.788 6.6C1.31267 5.38333 2.025 4.325 2.925 3.425C3.825 2.525 4.88333 1.81233 6.1 1.287C7.31667 0.762333 8.61667 0.5 10 0.5C11.3833 0.5 12.6833 0.762333 13.9 1.287C15.1167 1.81233 16.175 2.525 17.075 3.425C17.975 4.325 18.6873 5.38333 19.212 6.6C19.7373 7.81667 20 9.11667 20 10.5C20 11.8833 19.7373 13.1833 19.212 14.4C18.6873 15.6167 17.975 16.675 17.075 17.575C16.175 18.475 15.1167 19.1873 13.9 19.712C12.6833 20.2373 11.3833 20.5 10 20.5Z",
    fill: "#00DF80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.6956fb2b4993162b3a2959ae340ad749.svg";
export { ForwardRef as ReactComponent };